import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll position to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent the browser from restoring scroll position automatically
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      try {
        window.history.scrollRestoration = "manual";
      } catch (_) {
        // ignore
      }
    }

    // Scroll to top immediately on path change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
